// removed by extract-text-webpack-plugin
module.exports = {"Item":"_3kaKD","ItemPrimary":"_3wV02","ItemSecondary":"_125JN","ItemPrimarySmall":"_3fL5o","ItemSecondarySmall":"_1OD7_","ItemPrimaryFullWidth":"_1a0nE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FareInfo/FareRules/FareRulesItem/FareRulesItem.scss
// module id = 524
// module chunks = 0